import type en from "../en/nav";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  overview: "نظرة عامة",
  onlineStore: "المتجر الإلكتروني",
  builder: "منشئ المتجر",
  pages: "الصفحات",
  navigation: "القوائم",
  media: "مكتبة الوسائط",
  languages: "اللغات",
  assistant: "المساعد الذكي",
  catalog: "الكتالوج",
  products: "المنتجات",
  collections: "المجموعات",
  inventory: "المخزون",
  reviews: "التقييمات",
  sales: "المبيعات",
  orders: "الطلبات",
  returns: "المرتجعات",
  customers: "العملاء",
  discounts: "الخصومات",
  growth: "النمو",
  marketing: "التسويق",
  analytics: "التحليلات",
  settings: "الإعدادات",
  payments: "المدفوعات",
  shipping: "الشحن",
  taxes: "الضرائب",
  checkout: "إتمام الطلب",
  domains: "النطاقات",
  seo: "تحسين محركات البحث وإعادة التوجيه",
  team: "الفريق",
  storeDetails: "بيانات المتجر",
  publish: "الإطلاق والنشر",
  switchStore: "تبديل المتجر",
  allStores: "كل المتاجر…",
  newStore: "+ إنشاء متجر جديد",
  planBilling: "الباقة والفوترة",
  helpSupport: "المساعدة والدعم",
  openNav: "فتح القائمة",
  closeNav: "إغلاق القائمة",
  navLabel: "التنقل",
  storeNavLabel: "المتجر",
  notifications: "الإشعارات",
  notificationsUnread: "الإشعارات، {count} غير مقروءة",
  myStores: "متاجري",
  accountSecurity: "الحساب والأمان",
  support: "الدعم",
  platformAdmin: "إدارة المنصة",
  signOut: "تسجيل الخروج",
  stores: "المتاجر",
  billing: "الفوترة",
  accountNav: "الحساب",
  live: "منشور",
  suspended: "موقوف",
  notPublished: "غير منشور",
  viewStore: "عرض المتجر ↗",
  preview: "معاينة ↗",
  suspendedBanner: "تم إيقاف هذا المتجر من طرف المنصة{reason}. بياناتك في أمان —",
  contactSupport: "تواصل مع الدعم",
  publicAddress: "العنوان العام: {url}",
  language: "اللغة",
  adminOverview: "نظرة عامة",
  adminUsers: "المستخدمون",
  adminStores: "المتاجر",
  adminPlans: "الباقات",
  adminAi: "الذكاء الاصطناعي والأرصدة",
  adminPayments: "المدفوعات",
  adminSupport: "الدعم",
  adminContent: "المحتوى",
  adminHealth: "حالة النظام",
  adminAudit: "سجل التدقيق",
  adminEmails: "سجل البريد الإلكتروني",
  merchantView: "واجهة التاجر",
  exit: "خروج",
  skipToContent: "انتقل إلى المحتوى",
};

export default ar;
